import TextInput from '../TextInput';
import LimitsContainer from './LimitsContainer.jsx';
import { useEffect, useState } from 'react';

const LimitInput = ({ limit, setLimit }) => {
    limit = limit || {};

    useEffect(() => {
        if (!limit?.min_cancel_hours && limit?.min_hours) {
            setLimit({ ...limit, min_cancel_hours: limit?.min_hours });
        }
    }, []);

    return (
        <div>
            Prevent scheduling less than{' '}
            <span className="font-semibold">
                <TextInput
                    id="min_hours"
                    value={limit?.min_hours || ''}
                    onChange={newValue =>
                        setLimit({ ...limit, min_hours: newValue })
                    }
                    className="inline"
                    inputClassName="!w-16 mr-1"
                />
                hours
            </span>{' '}
            and more than{' '}
            <span className="font-semibold">
                <TextInput
                    id="max_days"
                    value={limit?.max_days || ''}
                    onChange={newValue =>
                        setLimit({ ...limit, max_days: newValue })
                    }
                    className="inline"
                    inputClassName="!w-16 mr-1"
                />
                days
            </span>{' '}
            in the future or canceling/rescheduling less than{' '}
            <span className="font-semibold">
                <TextInput
                    id="min_cancel_hours"
                    value={limit?.min_cancel_hours || ''}
                    onChange={newValue =>
                        setLimit({ ...limit, min_cancel_hours: newValue })
                    }
                    className="inline"
                    inputClassName="!w-16 mr-1"
                />
                hours
            </span>{' '}
            in advance .
        </div>
    );
};

const LimitDescription = ({ limit }) => {
    return (
        <div>
            Prevent booking less than
            <span className="font-semibold">
                {' '}
                {limit?.min_hours || 0} hours{' '}
            </span>
            in advance and more than
            <span className="font-semibold"> {limit?.max_days || 0} days </span>
            in the future or canceling/rescheduling less than{' '}
            <span className="font-semibold">
                {' '}
                {limit?.min_cancel_hours || limit?.min_hours || 0} hours{' '}
            </span>
            in advance.
        </div>
    );
};

const LimitsAdvanceTime = ({ limit }) => {
    if (!limit) {
        limit = {
            // This should match defaults in SchedulingLimit
            min_hours: 24,
            max_days: 365,
        };
    }

    return (
        <LimitsContainer
            title="Limit Booking Window"
            limit={limit}
            type="advance"
            LimitInput={LimitInput}
            LimitDescription={LimitDescription}
        />
    );
};

export default LimitsAdvanceTime;
